import { gql } from '@apollo/client';

const GET_VIDEO_BY_SLUG = gql`
  query GetVideoBySlug($slug: String!) {
    sectionsBy(slug: $slug) {
      video {
        tituloVideo
        enlace {
          title
          url
        }
        videoUrl
      }
    }
  }
`;

export { GET_VIDEO_BY_SLUG }